import { LoginUser } from './../models/DTO/LoginUser';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

 private _apiURI  : string;
 private _tokenName: string
 private _userData: string;
 baseUrl: string;

  constructor() {
    this._apiURI =  environment.API_URL;
      this._tokenName = 'auth_token';
      this._userData = 'userData';
   }

   getToken()
   {
     return this._tokenName;
   }

   getApiURI() {
    return this._apiURI ;
    
  }
   getUserData() {
    return this._userData;
  }
}
